import Instant from "core/js/class/instant";
import LocalDate from "core/js/class/local-date";
import { ajaxGet } from "core/js/spring-ajax";

const SCIM_TOKENS_ENDPOINT = "/authentication/rest/api/scim-tokens";

export type ScimTokenStatus = "ACTIVE" | "DEACTIVATED";

export type JsonScimToken = {
  id: number,
  last4DigitToken: string,
  issueDate: string,
  status: ScimTokenStatus,
  lastUsedAt?: string,
  deactivatedAt?: string,
  formattedIssueDate: string,
  formattedLastUsedDate?: string,
  formattedRevokedDate?: string,
};

export type JsonScimGeneratedToken = JsonScimToken & {
  rawToken?: string,
};

export async function getScimTokens(): Promise<Array<JsonScimToken>> {
  type JsonScimTokenList = { tokens: Array<JsonScimToken> };
  const tokens = (await ajaxGet<JsonScimTokenList>({ url: SCIM_TOKENS_ENDPOINT })).tokens;
  return tokens.map(token => ({
    ...token,
    formattedIssueDate: new LocalDate(token.issueDate).formatted("DD MMM YYYY"),
    formattedLastUsedDate: token.lastUsedAt ? new Instant(token.lastUsedAt).formatted() : undefined,
    formattedRevokedDate: token.deactivatedAt ? new Instant(token.deactivatedAt).formatted() : undefined,
  }));
}
